import React, { Component } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { PhysicianContext } from '.';
import { isAllowedReducedGridView } from '../../../../services/common/util';

class PhysicianBreadcrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Facility Management
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Physician
                                    </li>
                                </ol>
                            </nav>

                            <div style={{ display: 'flex' }}>
                                <h2 className="breadcrumb-title mr-3">Physician</h2>
                                <FormControlLabel
                                    value="includeArchived"
                                    control={
                                        <Switch
                                            checked={this.props.isArchived}
                                            onChange={this.props.onIsArchivedInformation}
                                        />
                                    }
                                    label={this.props.isArchived ? 'Hide Archives' : 'Show Archives'}
                                    labelPlacement="end"
                                    className="m-0 show-archives-control breadcrumb-control"
                                />
                                {isAllowedReducedGridView('facility') && (
                                    <PhysicianContext.Consumer>
                                        {({ isReducedGridView, onIsReducedGridView }) => (
                                            <FormControlLabel
                                                value="isReducedGridView"
                                                control={
                                                    <Switch
                                                        checked={isReducedGridView}
                                                        onChange={onIsReducedGridView}
                                                    />
                                                }
                                                label={isReducedGridView ? 'Reduced Grid View' : 'Full Grid View'}
                                                labelPlacement="end"
                                                className="m-0 show-reduced-control"
                                            />
                                        )}
                                    </PhysicianContext.Consumer>
                                )}
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PhysicianBreadcrumb;
